import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-first-click-test",
  "use": "foquz-icon-question-first-click-test-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-first-click-test\"><path d=\"M17.735 17.735L23 14.765 9 9l5.765 14 2.97-5.265zm0 0L23 23M9 1v2.462m-5.657-.119l1.74 1.74m9.574-1.74l-1.74 1.74m-7.833 7.833l-1.74 1.74M1 9h2.462\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol